import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/public/assets/images/hero/SocBanner.webp");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeading"] */ "/var/www/SOC/src/components/section-heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionCardsCaraousl"] */ "/var/www/SOC/src/sections/solution/v2/cards-carousel/index.tsx");
